<div class="add-manufacturer-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon>precision_manufacturing</mat-icon>
    </div>
    <div class="header-content">
      <h2 class="dialog-title">Add Manufacturer</h2>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" [formGroup]="sectionForm">
    <div class="form-row" >
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Manufacture Name *</label>
        <input type="text"  id="name" formControlName="name" class="form-control" placeholder="Manufacture Name" >
        <app-validation-error [formGroup]="sectionForm" [controlName]="'name'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="prefix" class="custom_label"> Manufacture Prefix </label>
        <input type="text"  id="prefix" formControlName="prefix" class="form-control" placeholder="Manufacture Prefix" >
        <app-validation-error [formGroup]="sectionForm" [controlName]="'prefix'"></app-validation-error>
      </div>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="onConfirm()">
      <mat-icon>check_circle</mat-icon>
      Add
    </button>
  </div>
</div>
